(function () {
  const cfg = window.AdapterFinder;
  if (!cfg) return;

  const $ = (id) => document.getElementById(id);

  const uploadZone  = $('af-upload-zone');
  const fileInput   = $('af-file-input');
  const preview     = $('af-preview');
  const previewImg  = $('af-preview-img');
  const analyzeBtn  = $('af-analyze-btn');
  const retryUpload = $('af-retry-upload');
  const loading     = $('af-loading');
  const result      = $('af-result');
  const errorMsg    = $('af-error');
  const modal       = $('af-modal');
  const modalClose  = $('af-modal-close');
  const modalSignIn = $('af-modal-signin');

  const SESSION_KEY = 'af_session';
  let imageBase64 = null;

  // ---- session persistence (back-button support) ----
  function saveSession(img, data) {
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify({ img, data })); } catch {}
  }

  function clearSession() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch {}
  }

  function restoreSession() {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return false;
      const { img, data } = JSON.parse(raw);
      if (!img || !data) return false;
      imageBase64 = img;
      previewImg.src = img;
      renderResult(data);
      setView('result');
      return true;
    } catch { return false; }
  }

  // ---- drag-and-drop ----
  uploadZone.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadZone.classList.add('af-drag-over');
  });
  uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('af-drag-over'));
  uploadZone.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadZone.classList.remove('af-drag-over');
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  });

  fileInput.addEventListener('change', (e) => {
    if (e.target.files[0]) handleFile(e.target.files[0]);
  });

  function handleFile(file) {
    if (!file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onload = (e) => resizeImage(e.target.result, 1024, (resized) => {
      imageBase64 = resized;
      previewImg.src = resized;
      clearSession();
      setView('preview');
    });
    reader.readAsDataURL(file);
  }

  function resizeImage(dataUrl, maxPx, callback) {
    const img = new Image();
    img.onload = () => {
      let w = img.width, h = img.height;
      if (w > maxPx || h > maxPx) {
        if (w >= h) { h = Math.round(h * maxPx / w); w = maxPx; }
        else        { w = Math.round(w * maxPx / h); h = maxPx; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      callback(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.src = dataUrl;
  }

  // ---- analyze ----
  analyzeBtn.addEventListener('click', () => {
    if (!cfg.customerId) {
      openLoginModal();
      return;
    }
    if (!imageBase64) return;
    runAnalysis();
  });

  retryUpload.addEventListener('click', reset);

  async function runAnalysis() {
    setView('loading');
    try {
      const res = await fetch(cfg.apiEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerId: String(cfg.customerId), imageBase64 })
      });

      if (!res.ok) {
        setView('error');
        return;
      }

      const data = await res.json();
      saveSession(imageBase64, data);
      renderResult(data);
      setView('result');
    } catch {
      setView('error');
    }
  }

  function renderResult(data) {
    if (!data.productHandle || data.adapterType === 'UNKNOWN') {
      result.innerHTML = `
        <div class="af-result-unknown">
          <p>We couldn't identify a specific connector type from that photo. Try a clearer, close-up image with good lighting showing just the connector end.</p>
          <div class="af-btn-row">
            <button class="af-btn af-btn-secondary" id="af-result-retry">Try Another Photo</button>
          </div>
        </div>`;
    } else {
      result.innerHTML = `
        <div class="af-result-card">
          <div class="af-result-badge">${escHtml(data.adapterType)}</div>
          <h3 class="af-result-name">${escHtml(data.productName)}</h3>
          <p class="af-result-desc">${escHtml(data.description)}</p>
          <div class="af-btn-row">
            <a href="${escHtml(data.productUrl)}" class="af-btn af-btn-primary">View Product →</a>
            <button class="af-btn af-btn-ghost" id="af-result-retry">Try Another Photo</button>
          </div>
        </div>`;
    }
    result.querySelector('#af-result-retry')?.addEventListener('click', reset);
  }

  function escHtml(str) {
    const d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  // ---- view states ----
  function setView(state) {
    uploadZone.hidden = state !== 'upload';
    preview.hidden    = state !== 'preview';
    loading.hidden    = state !== 'loading';
    result.hidden     = state !== 'result';
    errorMsg.hidden   = state !== 'error';
  }

  function reset() {
    imageBase64 = null;
    previewImg.src = '';
    fileInput.value = '';
    clearSession();
    setView('upload');
  }

  // ---- login modal ----
  function openLoginModal() {
    if (modalSignIn) {
      // Cookie persists across the shopify.com login redirect; sessionStorage does not
      var dest = encodeURIComponent(window.location.href);
      document.cookie = 'af_return=' + dest + '; path=/; domain=.wenstormcharge.com; max-age=3600; SameSite=Lax';
      modalSignIn.href = cfg.loginUrl;
    }
    modal.hidden = false;
  }

  modalClose.addEventListener('click', () => { modal.hidden = true; });
  modal.addEventListener('click', (e) => { if (e.target === modal) modal.hidden = true; });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') modal.hidden = true; });

  // ---- restore session on load (back-button) ----
  restoreSession();
})();
